module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrap"
  }, [_c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.show && _vm.userData.userId) ? _c('div', {
    staticClass: "user-box"
  }, [_c('div', {
    staticClass: "mongolia",
    class: _vm.showType
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [(_vm.userData.userId) ? _c('a', {
    attrs: {
      "onclick": "LXAnalytics('moduleClick', 'b_mw77r9gk');",
      "href": (_vm.isDPAPP ? 'dianping://user?userid=' : 'https://evt.dianping.com/synthesislink/13791.html?userid=') + _vm.userData.userId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "avatar"
  }, [_c('div', {
    staticClass: "pic"
  }, [(_vm.userData.avatar) ? _c('img', {
    attrs: {
      "src": _vm.userData.avatar
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.userData && _vm.userData.userLevel) ? _c('span', [_c('img', {
    staticClass: "i-level",
    attrs: {
      "src": 'https://p0.meituan.net/gpa/roundlv' + _vm.userData.userLevel + '.png'
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "tit"
  }, [_c('h3', [_vm._v(_vm._s(_vm.userData.userNickName))]), _vm._v(" "), (parseInt(_vm.userData.isVip) > 0) ? [_c('span', [_c('img', {
    staticClass: "i-vip",
    attrs: {
      "src": "https://p0.meituan.net/gpa/v.png"
    }
  })])] : (parseInt(_vm.userData.isVip) == 0) ? [_c('span', [_c('img', {
    staticClass: "i-vip",
    attrs: {
      "src": "https://p0.meituan.net/gpa/grayv.png"
    }
  })])] : _vm._e()], 2)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideoInited),
      expression: "isVideoInited"
    }],
    staticClass: "video-box",
    class: _vm.isFullHeight ? 'full-height' : _vm.envType
  }, [_c('div', {
    staticClass: "video-play"
  }, [_c('video', {
    attrs: {
      "id": "topic_video",
      "src": _vm.video.src,
      "preload": "auto",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), (!_vm.isShowVideo) ? [_c('a', {
    staticClass: "video-mask",
    on: {
      "click": function($event) {
        _vm.playVideo()
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "post_img",
      "src": _vm.video.poster
    }
  }), _vm._v(" "), _c('i')])] : _vm._e()], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "shop-info",
    class: _vm.showLogo
  }, [_c('div', {
    staticClass: "mongolia",
    class: _vm.showType
  }), _vm._v(" "), (_vm.comment.length) ? _c('div', {
    staticClass: "comment"
  }, [_c('p', [_vm._v(_vm._s(_vm.comment))])]) : _vm._e(), _vm._v(" "), (_vm.shopData.shopId) ? _c('div', {
    staticClass: "shop-box"
  }, [_c('a', {
    attrs: {
      "onclick": "LXAnalytics('moduleClick', 'b_qzckam19');",
      "href": (_vm.isDPAPP ? 'dianping://shopinfo?id=' : 'https://evt.dianping.com/synthesislink/13792.html?shopid=') + _vm.shopData.shopId
    }
  }), _vm._v(" "), (_vm.shopData.picture) ? _c('div', {
    staticClass: "pic",
    style: ('background-image: url(\'' + _vm.fixImgUrl(_vm.shopData.picture) + '\');')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('h4', [_vm._v(_vm._s(_vm.shopData.shopName) + _vm._s(_vm.shopData.branchName ? '(' + _vm.shopData.branchName + ')' : ''))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.shopData.shopRegion) + " " + _vm._s(_vm.shopData.shopCategory) + " " + _vm._s(_vm.shopData.avgPrice ? '￥' + _vm.shopData.avgPrice + '/人' : ''))])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('toast', {
    attrs: {
      "isShow": _vm.isShowToast,
      "msg": _vm.toastMsg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52ca5a34!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userShareVideo.vue
// module id = 614
// module chunks = 15